/*eslint-disable prefer-spread*/
// Disabled 'prefer-spread' as this code isn't compiled into ES5.

//         Backbone.js 1.0.0

//         (c) 2010-2013 Jeremy Ashkenas, DocumentCloud Inc.
//         Backbone may be freely distributed under the MIT license.
//         For all details and documentation:
//         http://backbonejs.org

// Initial Setup
// -------------

// Create local references to array methods we'll want to use later.
var slice = [].slice;

// toString used in the isEqual method
var toString = Object.prototype.toString;

// The top-level namespace. All public Backbone classes and modules will
// be attached to this. Exported for both the browser and the server.
var Backbone = {};

// Current version of the library. Keep in sync with `package.json`.
Backbone.VERSION = '1.0.0';

// Backbone.Events
// ---------------

// A module that can be mixed in to *any object* in order to provide it with
// custom events. You may bind with `on` or remove with `off` callback
// functions to an event; `trigger`-ing an event fires all callbacks in
// succession.
//
//         var object = {};
//         Object.assign(object, Backbone.Events);
//         object.on('expand', function(){ alert('expanded'); });
//         object.trigger('expand');
//
var Events = Backbone.Events = {

    // Bind an event to a `callback` function. Passing `"all"` will bind
    // the callback to all events fired.
    on: function(name, callback, context) {
        if (!eventsApi(this, 'on', name, [callback, context]) ||
                !callback) {
            return this;
        }
        this._events || (this._events = {});
        var events = this._events[name] || (this._events[name] = []);
        events.push({
            callback: callback,
            context: context,
            ctx: context || this,
        });
        return this;
    },

    // Bind an event to only be triggered a single time. After the first
    // time the callback is invoked, it will be removed.
    once: function(name, callback, context) {
        if (!eventsApi(this, 'once', name, [callback, context]) ||
                !callback) {
            return this;
        }
        var self = this;
        var called = false;
        var once = function() {
            if (called) {
                return;
            }
            called = true;
            self.off(name, once);
            callback.apply(this, arguments);
        };
        once._callback = callback;
        return this.on(name, once, context);
    },

    // Remove one or many callbacks. If `context` is null, removes all
    // callbacks with that function. If `callback` is null, removes all
    // callbacks for the event. If `name` is null, removes all bound
    // callbacks for all events.
    off: function(name, callback, context) {
        var retain;
        var ev;
        var events;
        var names;
        if (!this._events ||
                !eventsApi(this, 'off', name, [callback, context])) {
            return this;
        }
        if (!name && !callback && !context) {
            this._events = {};
            return this;
        }

        names = name ? [name] : Object.keys(this._events);
        for (var i = 0, l = names.length; i < l; i++) {
            name = names[i];
            if ((events = this._events[name])) {
                this._events[name] = retain = [];
                if (callback || context) {
                    for (var j = 0, k = events.length; j < k; j++) {
                        ev = events[j];
                        if ((callback && callback !== ev.callback &&
                                callback !== ev.callback._callback) ||
                                (context && context !== ev.context)) {
                            retain.push(ev);
                        }
                    }
                }
                if (!retain.length) {
                    delete this._events[name];
                }
            }
        }

        return this;
    },

    // Trigger one or many events, firing all bound callbacks. Callbacks are
    // passed the same arguments as `trigger` is, apart from the event name
    // (unless you're listening on `"all"`, which will cause your callback
    // to receive the true name of the event as the first argument).
    trigger: function(name) {
        if (!this._events) {
            return this;
        }
        var args = slice.call(arguments, 1);
        if (!eventsApi(this, 'trigger', name, args)) {
            return this;
        }
        var events = this._events[name];
        var allEvents = this._events.all;
        if (events) {
            triggerEvents(events, args);
        }
        if (allEvents) {
            triggerEvents(allEvents, arguments);
        }
        return this;
    },

    // Tell this object to stop listening to either specific events ... or
    // to every object it's currently listening to.
    stopListening: function(obj, name, callback) {
        var listeners = this._listeners;
        if (!listeners) {
            return this;
        }
        var deleteListener = !name && !callback;
        if (typeof name === 'object') {
            callback = this;
        }
        if (obj) {
            (listeners = {})[obj._listenerId] = obj;
        }
        for (var id in listeners) {
            if (listeners.hasOwnProperty(id)) {
                listeners[id].off(name, callback, this);
                if (deleteListener) {
                    delete this._listeners[id];
                }
            }
        }
        return this;
    },
};

// Regular expression used to split event strings.
var eventSplitter = /\s+/;

// Implement fancy features of the Events API such as multiple event
// names `"change blur"` and jQuery-style event maps `{change: action}`
// in terms of the existing API.
var eventsApi = function(obj, action, name, rest) {
    if (!name) {
        return true;
    }

    // Handle event maps.
    if (typeof name === 'object') {
        for (var key in name) {
            if (name.hasOwnProperty(key)) {
                obj[action].apply(obj, [key, name[key]].concat(rest));
            }
        }
        return false;
    }

    // Handle space separated event names.
    if (eventSplitter.test(name)) {
        var names = name.split(eventSplitter);
        for (var i = 0, l = names.length; i < l; i++) {
            obj[action].apply(obj, [names[i]].concat(rest));
        }
        return false;
    }

    return true;
};

// Internal dispatch function for triggering events.
var triggerEvents = function(events, args) {
    var ev;
    var i = -1;
    var l = events.length;
    while (++i < l) {
        (ev = events[i]).callback.apply(ev.ctx, args);
    }
};

// Aliases for backwards compatibility.
Events.bind = Events.on;
Events.unbind = Events.off;

// Allow the `Backbone` object to serve as a global event bus, for folks who
// want global "pubsub" in a convenient place.
Object.assign(Backbone, Events);

// Copy of `isEqual` from Underscore
var isEqual = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) {
        return a !== 0 || 1 / a === 1 / b;
    }
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) {
        return a === b;
    }
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) {
        return false;
    }
    switch (className) {
        // Strings, numbers, regular expressions, dates, and booleans are
        // compared by value.
        case '[object RegExp]':
        // RegExps are coerced to strings for comparison
        // (Note: '' + /a/i === '/a/i')
        case '[object String]':
            // Primitives and their corresponding object wrappers are
            // equivalent; thus, `"5"` is equivalent to `new String("5")`.
            return '' + a === '' + b;
        case '[object Number]':
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN
            if (+a !== +a) {
                return +b !== +b;
            }
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case '[object Date]':
        case '[object Boolean]':
            // Coerce dates and booleans to numeric primitive values. Dates
            // are compared by their millisecond representations. Note that
            // invalid dates with millisecond representations of `NaN` are
            // not equivalent.
            return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
        if (typeof a !== 'object' || typeof b !== 'object') {
            return false;
        }

        // Objects with different constructors are not equivalent, but
        // `Object`s or `Array`s from different frames are.
        var aCtor = a.constructor;
        var bCtor = b.constructor;
        if (aCtor !== bCtor && !(typeof aCtor === "function" &&
            aCtor instanceof aCtor && typeof bCtor === "function" &&
            bCtor instanceof bCtor) && ('constructor' in a &&
            'constructor' in b)) {
            return false;
        }
    }
    // Assume equality for cyclic structures. The algorithm for detecting
    // cyclic structures is adapted from ES 5.1 section 15.12.3, abstract
    // operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays
    // comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
        // Linear search. Performance is inversely proportional to the
        // number of unique nested structures.
        if (aStack[length] === a) {
            return bStack[length] === b;
        }
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is
        // necessary.
        length = a.length;
        if (length !== b.length) {
            return false;
        }
        // Deep compare the contents, ignoring non-numeric properties.
        while (length--) {
            if (!isEqual(a[length], b[length], aStack, bStack)) {
                return false;
            }
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var key;
        length = keys.length;
        // Ensure that both objects contain the same number of properties
        // before comparing deep equality.
        if (Object.keys(b).length !== length) {
            return false;
        }
        while (length--) {
            // Deep compare each member
            key = keys[length];
            if (!(b.hasOwnProperty(key) &&
                    isEqual(a[key], b[key], aStack, bStack))) {
                return false;
            }
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
};

var idCounter = 0;
var uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
};

// Backbone.Model
// --------------

// Backbone **Models** are the basic data object in the framework --
// frequently representing a row in a table in a database on your server.
// A discrete chunk of data and a bunch of useful, related methods for
// performing computations and transformations on that data.

// Create a new model with the specified attributes. A client id (`cid`)
// is automatically generated and assigned for you.
var Model = Backbone.Model = function(attributes, options) {
    var defaults;
    var attrs = attributes || {};
    options || (options = {});
    this.cid = uniqueId('c');
    this.attributes = {};
    this.url = options.url || this.url;
    this.urlRoot = options.urlRoot || this.urlRoot;
    if (options.parse) {
        attrs = this.parse(attrs, options) || {};
    }
    defaults = (typeof this.defaults === "function" ?
        this.defaults() : this.defaults);
    if (defaults) {
        for (var prop in defaults) {
            if (attrs[prop] === undefined) {
                attrs[prop] = defaults[prop];
            }
        }
    }
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
};

// Attach all inheritable methods to the Model prototype.
Object.assign(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function() {},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
        return Object.assign({}, this.attributes);
    },

    // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
        return Backbone.sync.apply(this, arguments);
    },

    // Get the value of an attribute.
    get: function(attr) {
        return this.attributes[attr];
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
        return this.get(attr) != null;
    },

    // Set a hash of model attributes on the object, firing `"change"`.
    // This is the core primitive operation of a model, updating the data
    // and notifying anyone who needs to know about the change in state.
    // The heart of the beast.
    set: function(key, val, options) {
        var attr;
        var attrs;
        var unset;
        var changes;
        var silent;
        var changing;
        var prev;
        var current;
        if (key == null) {
            return this;
        }

        // Handle both `"key", value` and `{key: value}` -style arguments.
        if (typeof key === 'object') {
            attrs = key;
            options = val;
        } else {
            (attrs = {})[key] = val;
        }

        options = Object.assign({}, options || {});

        // Run validation.
        if (!this._validate(attrs, options)) {
            return false;
        }

        // Extract attributes and options.
        unset = options.unset;
        silent = options.silent;
        changes = [];
        changing = this._changing;
        this._changing = true;

        if (!changing) {
            this._previousAttributes = Object.assign({}, this.attributes);
            this.changed = {};
        }
        current = this.attributes, prev = this._previousAttributes;

        // Check for changes of `id`.
        if (this.idAttribute in attrs) {
            this.id = attrs[this.idAttribute];
        }

        // For each `set` attribute, update or delete the current value.
        for (attr in attrs) {
            if (attrs.hasOwnProperty(attr)) {
                val = attrs[attr];
                if (!isEqual(current[attr], val)) {
                    changes.push(attr);
                }
                if (!isEqual(prev[attr], val)) {
                    this.changed[attr] = val;
                } else {
                    delete this.changed[attr];
                }
                if (unset) {
                    delete current[attr];
                } else {
                    current[attr] = val;
                }
            }
        }

        // Trigger all relevant attribute changes.
        if (!silent) {
            if (changes.length) {
                this._pending = true;
            }
            for (var i = 0, l = changes.length; i < l; i++) {
                this.trigger('change:' + changes[i], this,
                    current[changes[i]], options);
            }
        }

        // You might be wondering why there's a `while` loop here. Changes
        // can be recursively nested within `"change"` events.
        if (changing) {
            return this;
        }
        if (!silent) {
            while (this._pending) {
                this._pending = false;
                this.trigger('change', this, options);
            }
        }
        this._pending = false;
        this._changing = false;
        return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a
    // noop if the attribute doesn't exist.
    unset: function(attr, options) {
        return this.set(attr, void 0, Object.assign({}, options,
            {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
        var attrs = {};
        for (var key in this.attributes) {
            if (this.attributes.hasOwnProperty(key)) {
                attrs[key] = void 0;
            }
        }
        return this.set(attrs, Object.assign({}, options, {unset: true}));
    },

    // Fetch the model from the server. If the server's representation of
    // the model differs from its current attributes, they will be
    // overridden, triggering a `"change"` event.
    fetch: function(options) {
        options = options ? Object.assign({}, options) : {};
        if (options.parse === void 0) {
            options.parse = true;
        }
        var model = this;
        var success = options.success;
        options.success = function(resp) {
            if (!model.set(model.parse(resp, options), options)) {
                return false;
            }
            if (success) {
                success(model, resp, options);
            }
            model.trigger('sync', model, resp, options);
        };
        wrapError(this, options);
        return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
        var attrs;
        var method;
        var xhr;
        var attributes = this.attributes;

        // Handle both `"key", value` and `{key: value}` -style arguments.
        if (key == null || typeof key === 'object') {
            attrs = key;
            options = val;
        } else {
            (attrs = {})[key] = val;
        }

        // If we're not waiting and attributes exist, save acts as
        // `set(attr).save(null, opts)`.
        if (attrs && (!options || !options.wait) &&
                !this.set(attrs, options)) {
            return false;
        }

        options = Object.assign({validate: true}, options);

        // Do not persist invalid models.
        if (!this._validate(attrs, options)) {
            return false;
        }

        // Set temporary attributes if `{wait: true}`.
        if (attrs && options.wait) {
            this.attributes = Object.assign({}, attributes, attrs);
        }

        // After a successful server-side save, the client is (optionally)
        // updated with the server-side state.
        if (options.parse === void 0) {
            options.parse = true;
        }
        var model = this;
        var success = options.success;
        options.success = function(resp) {
            // Ensure attributes are restored during synchronous saves.
            model.attributes = attributes;
            var serverAttrs = model.parse(resp, options);
            if (options.wait) {
                serverAttrs = Object.assign(attrs || {}, serverAttrs);
            }
            if (typeof serverAttrs === "object" &&
                    !model.set(serverAttrs, options)) {
                return false;
            }
            if (success) {
                success(model, resp, options);
            }
            model.trigger('sync', model, resp, options);
        };
        wrapError(this, options);

        method = (this.isNew() ? 'create' :
            (options.patch ? 'patch' : 'update'));
        if (method === 'patch') {
            options.attrs = attrs;
        }
        xhr = this.sync(method, this, options);

        // Restore attributes.
        if (attrs && options.wait) {
            this.attributes = attributes;
        }

        return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // If `wait: true` is passed, waits for the server to respond before
    // removal.
    destroy: function(options) {
        options = options ? Object.assign({}, options) : {};
        var model = this;
        var success = options.success;

        var destroy = function() {
            model.trigger('destroy', model, options);
        };

        options.success = function(resp) {
            if (options.wait || model.isNew()) {
                destroy();
            }
            if (success) {
                success(model, resp, options);
            }
            if (!model.isNew()) {
                model.trigger('sync', model, resp, options);
            }
        };

        if (this.isNew()) {
            options.success();
            return false;
        }
        wrapError(this, options);

        var xhr = this.sync('delete', this, options);
        if (!options.wait) {
            destroy();
        }
        return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the
    // endpoint that will be called.
    url: function() {
        var urlRoot = (typeof this.urlRoot === "function" ?
            this.urlRoot() : this.urlRoot);
        var base = urlRoot || urlError();
        if (this.isNew()) {
            return base;
        }
        return base + (base.charAt(base.length - 1) === '/' ? '' : '/') +
            encodeURIComponent(this.id);
    },

    // **parse** converts a response into the hash of attributes to be
    // `set` on the model. The default implementation is just to pass the
    // response along.
    parse: function(resp, options) {
        return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
        return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks
    // an id.
    isNew: function() {
        return this.id == null;
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
        return this._validate({}, Object.assign(options || {},
            { validate: true }));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"`
    // event.
    _validate: function(attrs, options) {
        if (!options.validate || !this.validate) {
            return true;
        }
        attrs = Object.assign({}, this.attributes, attrs);
        var error = this.validationError =
            this.validate(attrs, options) || null;
        if (!error) {
            return true;
        }
        this.trigger('invalid', this, error,
            Object.assign(options || {}, {validationError: error}));
        return false;
    },
});

// Backbone.sync
// -------------

// Override this function to change the manner in which Backbone persists
// models to the server. You will be passed the type of request, and the
// model in question. By default, makes a RESTful Ajax request
// to the model's `url()`. Some possible customizations could be:
//
// * Use `setTimeout` to batch rapid-fire updates into a single request.
// * Send up the models as XML instead of JSON.
// * Persist models via WebSockets instead of Ajax.
Backbone.sync = function(method, model, options) {
    var type = methodMap[method];

    // Default options, unless specified.
    options = options || {};

    // Default JSON-request options.
    var params = {type: type, dataType: 'json'};

    // Ensure that we have a URL.
    if (!options.url) {
        var url = typeof model.url === "function" ? model.url() : model.url;
        params.url = url || urlError();
    }

    // Ensure that we have the appropriate request data.
    if (options.data == null && model && (method === 'create' ||
            method === 'update' || method === 'patch')) {
        params.contentType = 'application/json';
        params.data = JSON.stringify(options.attrs ||
            model.toJSON(options));
    }

    // Don't process data on a non-GET request.
    if (params.type !== 'GET') {
        params.processData = false;
    }

    // Make the request, allowing the user to override any Ajax options.
    var xhr = options.xhr = Backbone.ajax(Object.assign(params, options));
    model.trigger('request', model, xhr, options);
    return xhr;
};

// Map from CRUD to HTTP for our default `Backbone.sync` implementation.
var methodMap = {
    'create': 'POST',
    'update': 'PUT',
    'patch': 'PATCH',
    'delete': 'DELETE',
    'read': 'GET',
};

// Set the default implementation of `Backbone.ajax` to proxy through to
// `$`. Override this if you'd like to use a different library.
Backbone.ajax = function() {
    throw new Error("Please specify an Ajax lib for Backbone.ajax");
};

// Helpers
// -------

// Helper function to correctly set up the prototype chain, for subclasses.
// Similar to `goog.inherits`, but uses a hash of prototype properties and
// class properties to be extended.
var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by
    // you (the "constructor" property in your `extend` definition), or
    // defaulted by us to simply call the parent's constructor.
    if (protoProps && protoProps.hasOwnProperty('constructor')) {
        child = protoProps.constructor;
    } else {
        child = function() { return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    Object.assign(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function.
    var Surrogate = function() { this.constructor = child; };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate;

    // Add prototype properties (instance properties) to the subclass,
    // if supplied.
    if (protoProps) {
        Object.assign(child.prototype, protoProps);
    }

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
};

// Set up inheritance for the model.
Model.extend = extend;

// Throw an error when a URL is needed, and none is supplied.
var urlError = function() {
    throw new Error('A "url" property or function must be specified');
};

// Wrap an optional error callback with a fallback error event.
var wrapError = function(model, options) {
    var error = options.error;
    options.error = function(resp) {
        if (error) {
            error(model, resp, options);
        }
        model.trigger('error', model, resp, options);
    };
};

module.exports = Backbone;
